<template>
    <!-- 轮播 -->
    <div class="swiper">
        <van-swipe :autoplay="3000" @change="onChange">
            <van-swipe-item v-for="(item, index) in swiperData" :key="index">
                <van-image
                    lazy-load
                    fit="cover"
                    width="100%"
                    :height="188"
                    :src="item.image ? item.image : ''"
                    @click="jumpPage(item)"
                />
                <span class="swiper_txt van-ellipsis">{{ item.title }}</span>
            </van-swipe-item>
            <template #indicator>
                <div class="custom-indicator">
                    <span
                        v-for="(item, index) in swiperData"
                        :key="index"
                        :class="{ active: current === index }"
                    ></span>
                </div>
            </template>
        </van-swipe>
    </div>
</template>

<script>
import {navigate} from '@/pages/index/custom'
export default {
    props:  {
        swiperData: {
            type: Array,
            default: () => []
        },
        isUrl: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            // 轮播
            current: 0,
        }
    },
    methods: {
         // 轮播
        onChange(index) {
            this.current = index;
        },
        jumpPage(item) {
            console.log('轮播跳转1',item)
            // window.location.href='http://xmapp.test.zdg.sun0769.com/h5/index/#/audio/list?album=true&id=252691'
            if(item.url){
                window.location.href='http://xmapp.test.zdg.sun0769.com/h5/index/#/audio/list?album=true&id=252691'
                navigate('', item.url)
                 console.log('轮播跳转2',item.url)
            }else{
                 console.log('轮播跳转3',item.share_url)
                navigate('', item.share_url)
            }
            
        }
    }
}
</script>

<style lang="less" scoped>
.swiper {
    box-sizing: border-box;
    position: relative;
    padding: 0.5rem 0 1.375rem 0;
    .swiper_txt {
        position: absolute;
        left: 0;
        bottom: 12px;
        box-sizing: border-box;
        padding: 0 0.75rem;
        width: 100%;
        font-size: 18px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
    }
}
.van-swipe-item {
    width: 100%;
    height: 11.75rem;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
}
.van-swipe {
    position: static;
    border-radius: 8px;
    overflow: hidden;
}
.van-image {
    display: block;
}
.custom-indicator {
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    span {
        width: 1.875rem;
        height: 0.125rem;
        background-color: #eee;
        &.active {
            background-color: #ff4c67;
        }
    }
}
</style>
